import React from "react";
import { Link } from "react-router-dom";
import DOMPurify from "dompurify";

import { LoggedIn } from "../../utils/helper";
import Reveal from "./reveal";
import Divider from "./divider";
import EditLink from "./edit-link";
import "./columnContainer.css";

const ColumnContainer = ({ posts, id, expansionLink }) => {
  const userLoggedIn = LoggedIn();
  const STATIC_URL = process.env.REACT_APP_STATIC_URL;
  const header = posts;
  const details = posts;

  return (
    <div id={id} className="columnContainer">
      {/* HEADING OF SECTION */}
      {id === "header" && (
        <div className="heading">
          <Reveal
            column={1}
            card={
              <div className="card">
                <div className="card-body">
                  {header && <EditLink id={header.id} />}
                  {header && header.img && (
                    <div className="teamImg">
                      <img
                        src={`${STATIC_URL}/${header.img}`}
                        alt={header && header.title}
                      />
                    </div>
                  )}
                  <div className="cardHeader">{header && header.title}</div>
                  <Divider />
                  <div
                    className="cardText"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(header && header.desc),
                    }}
                  ></div>
                </div>
              </div>
            }
          />
          {/* LINK TO EXPAND DETAIL (ADD LIST OF SERVICES) */}
          {expansionLink}
        </div>
      )}
      {/* DETAIL OF SECTION */}
      {id !== "header" && (
        <div
          id={id === "services" ? "servicelist" : ""}
          className={id === "services" ? "detail collapse" : "detail"}
        >
          <div className="cards-container">
            {details.map((post, index) => (
              <div className="card-container" key={post.id}>
                <Reveal
                  column={index}
                  card={
                    <div className="card">
                      {post.id && (
                        <div className="card-body">
                          {post && <EditLink id={post.id} />}

                          {post.img && (
                            <div className="teamImg">
                              <img
                                src={`${STATIC_URL}/${post.img}`}
                                alt={post.title}
                              />
                            </div>
                          )}
                          <h2 className="cardHeader">{post.title}</h2>
                          <div
                            className="cardText"
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(post.desc),
                            }}
                          ></div>
                        </div>
                      )}
                    </div>
                  }
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ColumnContainer;
